export default class TpCreditMemoStatusChangeItem {
  constructor() {
    this.TpCreditMemoId = null;
    this.StatusChangeAction = '';
    this.Comment = '';

    this.Status = '';
    this.SubmittedBy = null;
    this.AssignedTo = null;
    this.CommentRequired = false;
  }
}
